/**
 * PerformancePlaceholder — reserved for Sprint 9.
 *
 * Explicit placeholder card so the owner knows the section exists and
 * where results will appear later. No metrics, no analytics, no fake
 * numbers.
 */
import { Card } from "@/shared/ui/card";
import { LineChart } from "lucide-react";

export function PerformancePlaceholder(): JSX.Element {
  return (
    <section data-testid="room-performance-placeholder">
      <div className="mb-6">
        <p className="text-xs uppercase tracking-widest text-muted-foreground mb-2">
          Performance
        </p>
        <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight">
          Results, when they arrive
        </h2>
      </div>
      <Card className="p-8 sm:p-10 text-center">
        <LineChart className="h-8 w-8 mx-auto text-muted-foreground mb-4" aria-hidden />
        <p className="text-base font-medium mb-2">Available after the campaign launches</p>
        <p className="text-sm text-muted-foreground max-w-md mx-auto">
          Once assets start publishing, this section will show how the
          campaign is performing across every channel — with the
          Performance department watching for anything that needs
          attention.
        </p>
      </Card>
    </section>
  );
}
